var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import SlideInModal from '../../ui/patterns/SlideinModal';
import FAQTable from '../../pages/FAQs/FAQTable';
import { ModalType } from '../../redux/ui/typings';
import i18n, { t } from '../../strings/i18n/i18n';
import { closeModal } from '../../redux/ui/ui.slice';
import { Trans } from 'react-i18next';
import LaunchPointName from '../../const/launchPointName';
import { closeModalHelper } from '../../ui/patterns/SlideinModal/helpers/closeHandlers';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import OnlineChatLink from '../../ui/atoms/OnlineChatLink';
import Link from './subcomponents';
var FAQs = function () {
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var _a = useSelector(function (state) { return state; }, shallowEqual), modalType = _a.ui.modalType, _b = _a.featureFlags, additionalInfo = _b.additionalInfo, redispute = _b.redispute, _c = _a.appConfig, customerCareNumber = _c.customerCareNumber, accountId = _c.accountId;
    var dispatch = useDispatch();
    /* istanbul ignore next */
    var handleLaunchChat = function () {
        pointOfNeedChat(LaunchPointName.Disputes, accountId);
        dispatch(closeModalHelper());
    };
    var getUploadDocsFAQQuestion = function () {
        if (additionalInfo) {
            return t('faqsQuestions.addCommentsDocs');
        }
        return t('faqsQuestions.supportingDocuments');
    };
    var getUploadDocsFAQAnswer = function () {
        if (additionalInfo) {
            return [t('faqsAnswers.addCommentsDocs')];
        }
        return [t('faqsAnswers.supportingDocumentsOff')];
    };
    var faqsArray = [
        {
            questionHeader: t('faqsQuestions.transaction'),
            answerBody: [
                t('faqsAnswers.transactionOne'),
                t('faqsAnswers.transactionTwo'),
                function (_a) {
                    var isExpanded = _a.isExpanded;
                    return (_jsx(Trans, { i18n: i18n, i18nKey: "faqsAnswers.transactionThree", components: [
                            _jsx(Link, { "data-cy": "disputes-faq-help-number", href: "tel:".concat(customerCareNumber), tabIndex: isExpanded ? 0 : -1 })
                        ], values: { customerCareNumber: customerCareNumber } }));
                },
                t('faqsAnswers.transactionFour')
            ]
        },
        {
            questionHeader: t('faqsQuestions.whySoManyQuestions'),
            answerBody: [t('faqsAnswers.whySoManyQuestions')]
        },
        {
            questionHeader: t('faqsQuestions.resolve'),
            answerBody: [t('faqsAnswers.resolve')]
        },
        {
            questionHeader: t('faqsQuestions.status'),
            answerBody: [t('faqsAnswers.status')]
        },
        {
            questionHeader: t('faqsQuestions.cancel'),
            answerBody: [t('faqsAnswers.cancel')]
        },
        {
            questionHeader: t('faqsQuestions.isDisputeCanceled'),
            answerBody: [t('faqsAnswers.isDisputeCanceled')]
        },
        {
            questionHeader: getUploadDocsFAQQuestion(),
            answerBody: getUploadDocsFAQAnswer()
        },
        {
            questionHeader: t('faqsQuestions.howToProvideAddInfo'),
            answerBody: [
                function (_a) {
                    var isExpanded = _a.isExpanded;
                    return (_jsx(Trans, { i18n: i18n, i18nKey: "faqsAnswers.howToProvideAddInfo", components: [
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-cy": "online-chat-link", "data-object": "button", "data-type": "online chat", onClick: handleLaunchChat, tabIndex: isExpanded ? 0 : -1 }, "online chat")
                        ] }));
                }
            ]
        },
        {
            questionHeader: t('faqsQuestions.iAmViewingMyDocuments'),
            answerBody: [t('faqsAnswers.iAmViewingMyDocuments')]
        }
    ];
    if (additionalInfo) {
        faqsArray.push({
            questionHeader: t('faqsQuestions.howManyDocuments'),
            answerBody: [t('faqsAnswers.howManyDocuments')]
        }, {
            questionHeader: t('faqsQuestions.whatFileTypes'),
            answerBody: [t('faqsAnswers.whatFileTypes')]
        });
    }
    faqsArray.push({
        questionHeader: t('faqsQuestions.howWillIknow'),
        answerBody: [t('faqsAnswers.howWillIknow')]
    }, {
        questionHeader: t('faqsQuestions.listOfCredits'),
        answerBody: [t('faqsAnswers.listOfCredits')]
    }, {
        questionHeader: t('faqsQuestions.disputeDenied'),
        answerBody: [
            function (_a) {
                var isExpanded = _a.isExpanded;
                return (_jsx(Trans, { i18n: i18n, i18nKey: "faqsAnswers.disputeDenied", components: [
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", "data-cy": "online-chat-link", "data-object": "button", "data-type": "online chat", onClick: handleLaunchChat, tabIndex: isExpanded ? 0 : -1 }, "online chat")
                    ] }));
            }
        ]
    });
    if (redispute) {
        faqsArray.push({
            questionHeader: t('faqsQuestions.redisputeMeaning'),
            answerBody: [t('faqsAnswers.redisputeMeaning')]
        });
    }
    var faqsWithId = faqsArray.map(function (faq, index) { return (__assign(__assign({}, faq), { id: index + 1 })); });
    var handleCloseModal = function () {
        dispatch(closeModal());
    };
    return modalType === ModalType.FAQs ? (_jsx(SlideInModal, __assign({ onCloseModal: handleCloseModal }, { children: _jsx(FAQTable, { faqs: faqsWithId }) }))) : null;
};
export default FAQs;
//# sourceMappingURL=index.js.map